import React, { useState } from "react";
import Modal from "../Modal";
import AddIcon from "@mui/icons-material/Add";
import TextBox from "../textbox";
import DeleteIcon from "@mui/icons-material/Delete";
import { add } from "date-fns";

const TravellersModal = ({
  open,
  setOpen,
  travellerList,
  setTravellerList,
  addTravellers,
  hide,
}) => {
  const [populateTravellers, setPopulateTravellers] = useState(false); // State for checkbox

  const handleChangeTraveller = (e, index) => {
    const { name, value } = e.target;
    const updatedTravellers = [...travellerList];
    updatedTravellers[index][name] = value;
    setTravellerList(updatedTravellers);
  };

  const handleDeleteTraveller = (index) => {
    const updatedTravellers = [...travellerList];
    updatedTravellers.splice(index, 1);
    setTravellerList(updatedTravellers);
  };

  const handleAddTraveller = () => {
    setTravellerList([
      ...travellerList,
      {
        title: "Mr",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        dob: "",
      },
    ]);
  };

  const handleSubmit = () => {
    if (populateTravellers === true) {
      const firstTraveller = travellerList[0];
      const updatedTravellers = travellerList.map(() => {
        const { _id, ...rest } = firstTraveller; // remove _id
        return { ...rest };
      });
      setTravellerList(updatedTravellers);
      addTravellers(updatedTravellers);
    } else {
      addTravellers(travellerList);
    }
  };
  const handlePopulateTravellers = (checked) => {
    setPopulateTravellers(checked);
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      title="Add Travelers"
      size="lg"
    >
      {/* Checkbox to toggle showing only the first traveller */}

      {(populateTravellers ? travellerList.slice(0, 1) : travellerList).map(
        (traveller, index) => (
          <>
            <div
              key={index}
              className="d-flex align-items-center mt-3 justify-content-center mt-1 adtm"
              style={{ gap: "10px" }}
            >
              <select
                value={traveller.title}
                onChange={(e) => handleChangeTraveller(e, index)}
                name="title"
                style={{
                  border: "1px solid var(--light-grey)",
                  borderRadius: "8px",
                }}
              >
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Miss">Miss</option>
              </select>

              <TextBox
                type="text"
                placeholder="First Name"
                name="firstName"
                value={traveller.firstName}
                onChange={(e) => handleChangeTraveller(e, index)}
                style={{ width: "90%" }}
              />
              <TextBox
                type="text"
                placeholder="Last Name"
                name="lastName"
                value={traveller.lastName}
                onChange={(e) => handleChangeTraveller(e, index)}
                style={{ width: "90%" }}
              />
              <TextBox
                type="email"
                placeholder="Email"
                name="email"
                value={traveller.email}
                onChange={(e) => handleChangeTraveller(e, index)}
                style={{ width: "90%" }}
              />
              <TextBox
                type="phone"
                placeholder="Phone"
                name="phone"
                value={traveller.phone}
                onChange={(e) => handleChangeTraveller(e, index)}
                style={{ width: "90%" }}
              />
              <TextBox
                type="text"
                placeholder="Age"
                name="age"
                value={traveller.age}
                onChange={(e) => handleChangeTraveller(e, index)}
                style={{ width: "20%" }}
                fullWidth={false}
              />

              <button
                className="icon-btn"
                style={{ color: "var(--red-color)" }}
                onClick={() => handleDeleteTraveller(index)}
              >
                {hide !== true ? <DeleteIcon /> : <></>}
              </button>
            </div>
            {hide === true && index === 0 && (
              <div className="d-flex align-items-center justify-content-center mt-4 mb-3">
                <label
                  htmlFor="populateTravellers"
                  style={{ marginRight: "10px" }}
                >
                  Do you want to use the first traveller for all others?
                </label>
                <input
                  type="checkbox"
                  id="populateTravellers"
                  checked={populateTravellers}
                  onChange={(e) => handlePopulateTravellers(e.target.checked)}
                  style={{ width: "20px", height: "20px" }}
                />
              </div>
            )}
          </>
        )
      )}

      {hide !== true ? (
        <div style={{ textAlign: "center" }}>
          <button className="icon-btn" onClick={handleAddTraveller}>
            <AddIcon />
          </button>
        </div>
      ) : (
        <></>
      )}

      <div
        className="d-flex align-items-center mt-4 justify-content-end"
        style={{ gap: "20px" }}
      >
        <button className="btn-outlined" onClick={() => setOpen(false)}>
          Cancel
        </button>
        <button className="btn-contained" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </Modal>
  );
};

export default TravellersModal;
